export const constantUrl = {
  AllowExtension: [
    "jpg",
    "jpeg",
    "png",
    "xls",
    "xlsx",
    "doc",
    "docx",
    "pdf",
    "mp4",
    "avi",
    "mkv",
    "wmv",
    "flv",
    "webm",
    "mp3",
    "wav",
    "aac",
    "flac",
    "ogg",
    "m4a",
    "alac",
    "wma",
    "opus",
    "amr",
    "3gp",
    "3gpp",
    "caf",
    "mpeg",
    "mpg",
  ],

  //==================================================================================//

  // apiEndpointWeb: window.location.href.split('#')[0] + '#/',
  // apiEndpoint: window.location.href.split('#')[0] + 'api',
  // hubUrl: window.location.href.split('#')[0] + "api/hubs",
  // apiEndpointUploadDoc: window.location.href.split('#')[0] + "uploadDoc",
  // apiProfilePicUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/Employee/ProfilePic/",
  // customerProfilePicUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/Customer/",
  // CrcApplicationDocUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/ApplicationDocument/",
  // SenctionTemplateImageUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/TemplateDocument/",
  // LoanDocUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/LoanDocument/",
  // OthersDocUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/Others/",
  // AccountDocUrl: window.location.href.split('#')[0] + "uploadDoc/wwwroot/Document/Account/",
  //==================================================================================//
  /*Demo*/
  apiEndpointWeb: "https://demo.finnaux.in/#/",
  // apiEndpoint: "https://demo.finnaux.in/api",
  //hubUrl: "https://demo.finnaux.com/api/hubs",
  apiEndpointUploadDoc: "https://demo.finnaux.in/uploadDoc",
  apiProfilePicUrl:
    "https://demo.finnaux.in/uploadDoc/wwwroot/Document/Employee/ProfilePic/",
  customerProfilePicUrl:
    "https://demo.finnaux.in/uploadDoc/wwwroot/Document/Customer/",
  CrcApplicationDocUrl:
    "https://demo.finnaux.in/uploadDoc/wwwroot/Document/ApplicationDocument/",
  SenctionTemplateImageUrl:
    "https://demo.finnaux.in/uploadDoc/wwwroot/Document/TemplateDocument/",
  LoanDocUrl:
    "https://demo.finnaux.in/uploadDoc/wwwroot/Document/LoanDocument/",
  OthersDocUrl: "https://demo.finnaux.in/uploadDoc/wwwroot/Document/Others/",
  AccountDocUrl: "https://demo.finnaux.in/uploadDoc/wwwroot/Document/Account/",
  MobileAPKUrl: "https://demo.finnaux.in/uploadDoc/wwwroot/Document/MobileAPK/",
  apiEndpoint: "http://localhost:5215",
  // apiEndpoint: "http://192.168.0.11:5215",

  hubUrl: "https://demo.finnaux.in/api/hubs",
  //==================================================================================//
};
